import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Button, Modal, ModalBody } from 'reactstrap';
import { WebUrl } from '../../util/Constant';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { performLogout } from '../../redux/AuthAction';

const Confirmation = props => {
    var { t } = useTranslation();
    const _classname = "bettingModal";
    const _dispatch = useDispatch();
    const _history = useHistory();
    const { isModalOpen, setModalOpen, fromConfirmationFooter } = props;
    const toggle = () => setModalOpen(!isModalOpen);

    return (
        <Modal isOpen={isModalOpen} toggle={toggle} className={_classname} centered>
            <ModalBody className="text-center">
                <p className="f-s-20 sfp-bold">{t("ARE_YOU_SURE_EXIT_TITLE")}</p>
                <p className="f-s-17 theme-text-3 sfp-medium">{t("ARE_YOU_SURE_EXIT_TEXT")}</p>
                <div className="d-flex justify-content-center">
                    <Button onClick={toggle} className="theme-btn-4 btn btn-md cancel-btn m-r-5">{t("CANCEL")}</Button>
                    <Button onClick={() => { _dispatch(performLogout()); }} className="theme-btn-1 btn btn-md m-l-5">{t("LEAVE")}</Button>
                </div>
            </ModalBody>
        </Modal>
    )
}

export default Confirmation;